module.exports = __webpack_public_path__ + "media/assets/Complete-bbafee1701c12a314926364078830c87.svg";